import React from "react";
import { Database, Calendar } from "lucide-react";
export const buildFilters = (getDynamicFilters, translate) => {
  return [
    {
      mainFilters: [
        {
          key: "ReconciliationStreamName",
          displayName: translate("reconciliation-runs.filters.stream"),
          icon: () => <Database size={18} />,
          components: [
            {
              name: translate("reconciliation-runs.filters.reconciliations"),
              type: "title",
              key: "title",
            },
            {
              name: translate(
                "reconciliation-runs.filters.reconciliationStreamStatus"
              ),
              type: "checkboxGroup",
              key: "ReconciliationRunStatusTag",
              values: getDynamicFilters("ReconciliationRunStatusTag"),
              filterType: "checkbox",
              operator: "EQ",
            },
            {
              name: translate(
                "reconciliation-runs.filters.reconciliationStreamName"
              ),
              type: "checkboxGroup",
              key: "ReconciliationStreamTag",
              values: getDynamicFilters("ReconciliationStreamTag"),
              filterType: "checkbox",
              operator: "EQ",
            },
          ],
        },
        {
          key: "NextReconciliationRun",
          displayName: translate("reconciliation-runs.filters.dates"),
          icon: () => <Calendar size={18} />,
          components: [
            {
              name: translate("reconciliation-runs.filters.selectDate"),
              type: "title",
              key: "title",
            },
            {
              name: translate("reconciliation-runs.filters.startDate"),
              type: "dateInput",
              inputType: "date",
              key: "StartDate",
              placeHolder: translate("reconciliation-runs.filters.startDate"),
              prefix: "",
              filterType: "date",
              dynamicMaxDate: (selectedValues) => {
                return selectedValues?.EndDate?.value;
              },
            },
            {
              name: translate("reconciliation-runs.filters.endDate"),
              type: "dateInput",
              inputType: "date",
              key: "EndDate",
              placeHolder: translate("reconciliation-runs.filters.endDate"),
              prefix: "",
              filterType: "date",
              dynamicMinDate: (selectedValues) => {
                return selectedValues?.StartDate?.value;
              },
            },
            {
              name: translate("reconciliation-runs.filters.businessDay"),
              type: "dateInput",
              inputType: "date",
              key: "BusinessDay",
              placeHolder: translate("reconciliation-runs.filters.businessDay"),
              prefix: "",
              filterType: "date",
            },
          ],
        },
        {
          key: "ReconciliationRunId",
          displayName: translate("reconciliation-runs.filters.runId"),
          icon: () => <Calendar size={18} />,
          components: [
            {
              name: translate("reconciliation-runs.filters.runId"),
              type: "title",
              key: "title",
            },
            {
              type: "numberInput",
              key: "RunId",
              placeHolder: translate("shared.filterRunID"),
              decimalPoint: 0,
              step: 1,
              operator: "EQ",
              filterType: "string",
              hasDecimal: false,
            },
          ],
        },
      ],
    },
  ];
};
